import { render, staticRenderFns } from "./entregas.vue?vue&type=template&id=43b5df7f&scoped=true"
import script from "./entregas.vue?vue&type=script&lang=js"
export * from "./entregas.vue?vue&type=script&lang=js"
import style0 from "./entregas.vue?vue&type=style&index=0&id=43b5df7f&prod&lang=scss"
import style1 from "./entregas.vue?vue&type=style&index=1&id=43b5df7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5df7f",
  null
  
)

export default component.exports